<template>

    <div class="container">
        
        <!--[start] Sidebar Chat Button -->
        <table cellpadding="4" cellspacing="0" class="mt-2" v-show="this.$props.show_sidebar == true">
            <tbody>
                <tr>
                    <td valign="top" width="65px">
                        <div class="pl-2">
                            <img :src="this.customer_support_image" width="60px">
                        </div>
                    </td>

                    <td valign="top" class="pl-2 text-align-center">
                        <div class="cs-speech-bubble">
                            <a href="" @click.prevent="openChatBox()">Chat Support</a>
                        </div>
                        <div class="small pt-1 pb-1">                        
                            <a href="JavaScript:PopupCenter('https://www.mytutor-jpn.com/info/2021/0816220249.html','Chat Support ご利用方法',900,820);">Chat Support ご利用方法</a>
                        </div>
                    </td>
                </tr>

            </tbody>
        </table>
        <!--[end] Sidebar Chat Button -->
       

        <div id="fileUpload" class="position-bottom-right" style="display:none">
            <file-upload
                name="file"
                class="btn btn-primary"
                extensions="jpeg,jpg,gif,pdf,png,webp"
                accept="image/png, application/pdf, image/gif, image/jpeg, image/webp"
                v-model="files"
                post-action="/uploader/fileUploader"            
                :data="{ 
                    'current_chatbox_userid': this.current_chatbox_userid,
                    'message_type': 'MEMBER',            
                    'folder': 'notes',                
                }"
                :headers="{'X-CSRF-TOKEN': this.csrf_token }"
                :multiple="true"
                :drop="true"
                :drop-directory="true"
                @input="updatetValue"
                @input-file="inputFile"
                @input-filter="inputFilter" ref="upload">      
            </file-upload>
        </div>

        <!--[START] CHAT BUTTON -->
        <div class="floatingChatIcon" v-show="showFloatingChatIcon == true && showFloatingIcon">
            <div class="position-bottom-right" v-show="showChatbox == false">
                <b-button class="chat-button mb-4 mr-5"  variant="primary" @click="openChatBox">
                    <h2 class="fa fa-comments mt-1"></h2>
                    <span class="badge badge-danger text-white small m-0 p-1" v-show="this.unread_message_count > 0">
                    {{this.unread_message_count}}
                    </span>
                </b-button>
            </div>
        </div>
        <!--[END] CHAT BUTTON -->
       
        <div class="position-bottom-right mr-5" v-show="showChatbox == true">

            <div class="chatboxes">

                <div class="chatbox" v-for="(chatbox, index) in this.chatboxes" :key="'chatbox_' + index" style="width:490px;">
                
                    <div class="card">

                       
                        <div class="card-header rounded-top bg-blue text-white" style="padding: 4px 10px 0px;">
                            <div class="small float-left font-weight-bold">Customer Support</div>
                            <span class="float-right">
                                <a href="" @click.prevent="closeChatBox"><i class="fas fa-times-circle text-white"></i></a>
                            </span>
                        </div>
                        <div class="card-body bg-white pb-4" style="min-height:250px;">

                            <div id="user-chatlog" class="user-chatlog border rounded text-center">

                                <button v-on:click="getChatHistory(chatbox, false)" id="floating-history-btn" class="btn btn-xs btn-secondary" 
                                    v-show="historyNotifier == true && isFetching == false">
                                    Fetch History                                                
                                </button>

                                <button v-show="historyNotifier == true && isFetching == true"  id="floating-history-btn" class="btn btn-xs btn-primary">
                                    <i class="fas fa-sync fa-spin"></i>  Loading
                                </button>


                             

                                <div class="chatlog-wrapper">

                                    <!--[START] CHATLOG MESSAGE-->
                                    <div class="chat" v-for="(chatlog, chatlogIndex) in chatlogs[chatbox.userid]" :key="'my_chatlog_' + (chatlog.id || ('i' + chatlogIndex))">

                                        <div class="row" v-if="chatlog.sender.type == 'CHAT_SUPPORT'">  

                                        
                                            <div class="col-md-2">   
                                                <div class="p-0" v-if="chatlogIndex == 0 || chatlogs[chatbox.userid][chatlogIndex - 1].sender.type !== 'CHAT_SUPPORT'">  

                                                    <b-img thumbnail fluid :src="customer_support_image" rounded="circle" alt="CHAT_SUPPORT"></b-img>                                               
                                                </div>
                                            </div>      
                                            <div class="col-md-10 pl-0">
                                                <div class="small text-left mt-2" v-if="chatlogIndex == 0 || chatlogs[chatbox.userid][chatlogIndex - 1].sender.type !== 'CHAT_SUPPORT'">                           
                                                    {{ chatlog.sender.nickname }}, {{ chatlog.time  }}                             
                                                </div>
                                                <div class="chat-support-message" v-html="formatMessage(chatlog.sender.message)"></div>
                                            </div>
                                        </div>


                                        <div class="row" v-if="chatlog.sender.type == 'MEMBER'" >   
                                            <div class="col-md-10">       

                                                <div class="member-info" v-if="chatlogIndex == 0 || chatlogs[chatbox.userid][chatlogIndex - 1].sender.type !== 'MEMBER'">    
                                                    <span class="small">{{ chatlog.sender.nickname }}, {{ chatlog.time  }}</span>                       
                                                </div>

                                                <div class="member-message-container">
                                                    <div class="member-message" v-html="formatMessage(chatlog.sender.message)"></div>
                                                </div>

                                            </div>
                                            <div class="col-md-2">
                                                <div class="p-0" v-if="chatlogIndex == 0 || chatlogs[chatbox.userid][chatlogIndex - 1].sender.type !== 'MEMBER'">
                                                    <b-img thumbnail fluid :src="chatlog.sender.user_image" rounded="circle" alt="Circle image"></b-img>     
                                                </div>
                                            </div>
                                        
                                        </div>
                                    </div>
                                    <div class="chat" v-for="(item, outboxIndex) in outbox" :key="item.clientId">
                                        <div class="row">
                                            <div class="col-md-10">
                                                <div class="member-message-container">
                                                    <div class="member-message is-failed" v-html="formatOutboxMessage(item.message)"></div>
                                                </div>
                                                <div class="member-chat-unsent">
                                                    <span>Not sent</span>
                                                    <button type="button" class="member-chat-resend" :disabled="!!resendingIds[item.clientId]" @click="resendOutbox(item, chatbox)">
                                                        {{ resendingIds[item.clientId] ? 'Sending...' : 'Resend' }}
                                                    </button>
                                                    <button type="button" class="member-chat-discard" :disabled="!!resendingIds[item.clientId]" @click="discardOutbox(item, chatbox)">
                                                        Delete
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="p-0" v-if="outboxIndex === 0 && !threadEndsWithMember(chatbox)">
                                                    <b-img thumbnail fluid :src="user_image" rounded="circle" alt="Circle image"></b-img>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                     <!--[END] CHATLOG MESSAGE-->

                                </div>

                            </div>
                            

                            <div id="user-reply-container" class="row mt-2">

                                <div class="col-9 pr-0 mr-0">
                                    <div v-for="(file, index) in files" :key="file.id" class="image-prieview-container bg-light  w-25 d-inline-block p-1 border border-light rounded">
                                        <div class="remove-image-upload float-right">
                                            <a class="" href="#" @click.prevent="$refs.upload.remove(file)" style="padding:5px; background-color:#fff; color:#000">X</a>
                                        </div>

                                        <div  v-if="file.type == 'image/jpeg' || file.type == 'image/png'" >
                                            <img class="w-100" :src="file.thumb" :id="'image-preview-'+index">  
                                        </div>
                                        
                                        <div v-else>
                                            <div>
                                                <i class="far fa-file" style="font-size:110px"></i>
                                            </div>
                                        </div>

                                        <div class="progress" v-if="file.active || file.progress !== '0.00'">
                                            <div :class="{'progress-bar': true, 'progress-bar-striped': true, 'bg-danger': file.error, 'progress-bar-animated': file.active}"
                                                role="progressbar"
                                                :style="{width: file.progress + '%'}"
                                            >{{file.progress}}%</div>
                                        </div>

                                    </div>  
                                </div>


                                <div class="col-9 pr-0 mr-0">
                                    <input id="message" 
                                        v-on:keyup.13="sendMessage(chatbox, index)"  
                                        type="text" 
                                        autocomplete="off"
                                        class="form-control form-control-sm mb-1" 
                                        v-model="message[index]" 
                                        placeholder="Type a message" 
                                        aria-label="Type a message"
                                    >
                                </div>
                                <div class="col-3 px-1">
                                    <div id="attach-button" class="input-group-append d-inline-block float-left">
                                        <label id="file-select-button" for="file" class="btn btn-primary mr-1 btn-sm">
                                            <i class="fas fa-paperclip"></i>
                                        </label>
                                    </div>

                                    <div id="send-button" class="input-group-append d-inline-block float-left">
                                        <button type="button"  @click.prevent="$refs.upload.active = false; sendMessage(chatbox, index); " class="btn btn-sm btn-primary">
                                            <i class="fa fa-paper-plane" aria-hidden="true"></i>
                                        </button>
                                    </div>     

                                    <span class="button-controls" style=" display:none">
                                        <button id="startUpload" type="button" class="btn btn-sm btn-success" v-if="!$refs.upload || !$refs.upload.active" @click.prevent="$refs.upload.active = true">
                                            <i class="fa fa-arrow-up" aria-hidden="true"></i>Start Upload
                                        </button>

                                        <button type="button" class="btn btn-sm btn-danger" v-else @click.prevent="$refs.upload.active = false">
                                            <i class="fa fa-stop" aria-hidden="true"></i>Stop Upload
                                        </button>
                                    </span>                                  
                                </div>  

                            </div>

                        </div>
                    </div>


                </div> 

            </div>
        </div>


        <ImageViewerComponent ref="ImageViewerComponent" />
    </div>


</template>

<script>
import Vue from 'vue';
import VueSocketIO from 'vue-socket.io';
import FileUpload from 'vue-upload-component'
import ImageViewerComponent from "../../image/imageViewerComponent.vue"; // Import the modal component

// Chat server is Socket.IO v2. Use vue-socket.io's bundled socket.io-client@2
// — do NOT import root socket.io-client@4 (it never connects to this server).
const DEFAULT_CHATSERVER_URL = 'https://chatserver.mytutor-jpn.info:30001/';

function ensureChatSocketPlugin(url) {
    if (Vue.prototype.$socket) {
        return;
    }
    Vue.use(new VueSocketIO({
        debug: false,
        connection: url || DEFAULT_CHATSERVER_URL,
    }));
}

ensureChatSocketPlugin(DEFAULT_CHATSERVER_URL);

export default {
  name: "member-floating-chat-component",
  components: {
    FileUpload, ImageViewerComponent
  },
  sockets: {
    connect() {
      console.log('[chat-support] connected to chat server');
      this.registerUser();
    },
    connect_error(err) {
      console.warn('[chat-support] connect_error:', err && err.message ? err.message : err);
    },
    disconnect(reason) {
      console.warn('[chat-support] disconnected:', reason);
    },
    update_user_list(users) {
      this.updateUserList(users);
    },
    PRIVATE_MESSAGE(data) {
      this.onPrivateMessage(data);
    },
  },
  data() {
    return {            

        showFloatingChatIcon: true,

        //history is fetching status
        isFetching: false,
        interval: "",

        //first load on opening chatbox
        firstLoad: true,   

     

        message: [],
        outbox: [],
        resendingIds: {},
        sendingText: false,

        
        users: [],

        //chat boxes
        showChatbox: false,

        chatboxes: [],
        chatlogs: [],
        message_count: 0,
        unread_message_count: 0,

    
        //this will hold the current recipient userid
        current_chatbox_userid: "",

        //uploader
        files: [],

        //History Loaders
        loadingHistory: false,
        historyNotifier: true,

        //buttons
        ButtonSend: null,
        ButtonUpload: null,

        //page
        page:[],
    
    };
  },
  props: {
    userid: String,
    username: String,
    nickname: String,
    user_image: String,
    api_token: String,
    csrf_token: String,   
    chatserver_url: String,
    customer_support_image: String,
    show_sidebar: Boolean,
    show_floating_icon: {
      type: Boolean,
      default: true,
    },
  },
  methods: 
  {
    getChatSocket() {
        return this.$socket || null;
    },
    registerUser() {
        const sock = this.getChatSocket();
        if (!sock) {
            console.warn('[chat-support] $socket missing — cannot REGISTER');
            return;
        }
        sock.emit('REGISTER', this.getUser());
    },
    onPrivateMessage(data) {
            if (!data || !data.sender) {
                return;
            }
            var signal = this.readSupportEdit(data);
            if (signal) {
                if (data.recipient && String(data.recipient.userid) === String(this.userid)) {
                    if (signal.kind === "delete") {
                        this.removeSupportMessage(signal.historyId);
                    } else if (!this.applyEditedSupportMessage(signal.historyId, signal.message)) {
                        this.applyLatestSupportEdit(signal.message, signal.historyId);
                    }
                }
                return;
            }
            if (data.sender.history_id && data.recipient && String(data.recipient.userid) === String(this.userid)) {
                if (this.applyEditedSupportMessage(data.sender.history_id, data.sender.message)) {
                    return;
                }
            }
            let admin = {
                userid: 1,
                username: "admin",
            }

            // Own messages are appended after a successful save.
            if (data.sender && data.sender.username == this.username) 
            {
                this.$nextTick(() => this.scrollToEnd());
                return;
            }

            if (data.recipient && String(data.recipient.userid) == String(this.userid)) 
            {

                this.openChatBox(admin);

                console.log("sent from support")

                this.unread_message_count++;


                let sender_customer_support = {
                    'userid': data.sender.userid,
                    'username': data.sender.username,   
                    'nickname': data.sender.nickname,
                    'message': data.sender.message,
                    'type': data.sender.type,
                };

                if (!this.chatlogs[admin.userid]) {
                    this.$set(this.chatlogs, admin.userid, []);
                }

                this.chatlogs[admin.userid].push({
                        id: data.sender.history_id || null,
                        time: data.time,
                        sender: sender_customer_support,
                });      

                this.$forceUpdate();  

                this.$nextTick(function()
                {
                    this.scrollToEnd(); 

                });
            
                //play audio
                let audio = new Audio("/mp3/message-sent.mp3");
                audio.play();            
            }  
    },
    getAdmin() {
        return {
            userid: 1,
            username: "admin",
            status: 'offline',
        }
    },
    prependHTTPS(url) {
        if (!/^https?:\/\//i.test(url)) {
            url = 'https://' + url;
            return url;
        } else {

            return url;
        }
    },
    formatMessage(message) 
    {
       if (message === null || message === undefined) {
           return "";
       }
       return this.urlify(String(message).replace(/^\[\[cs-(?:edit|delete):\d+\]\]/, ""));
    },

    imageViewerClick(event) {
      // Check if the clicked element has the "img_preview" class
      if (event.target.classList.contains("img_preview")) {
        event.preventDefault();
        // Extract the image URL from the clicked element and open the modal
        const imageUrl = event.target.getAttribute("src");   
        this.$refs.ImageViewerComponent.openModal(imageUrl); // Open the modal

      }
    },     
    linkify_v1(str) {
       return str.replace(/((http(s)?(\:\/\/))?(www\.)?([\w\-\.\/])*(\.[a-zA-Z]{2,3}\/?))(?!(.*a>)|(\'|\"))/g, '<a href="$1"  target="_blank" >$1</a>');    
    },
    linkify(text) {

        // Create a temporary DOM element
        var tempElement = document.createElement('div');
        tempElement.innerHTML = text;

        // Get all text nodes within the temporary DOM element
        var textNodes = [];
        var treeWalker = document.createTreeWalker(tempElement, NodeFilter.SHOW_TEXT, null, false);
        while (treeWalker.nextNode()) {
            textNodes.push(treeWalker.currentNode);
        }

        // Replace URLs with anchor tags in text nodes
        textNodes.forEach(function(node) {
            var nodeText = node.nodeValue;
            var urlRegex = /((http|https|ftp):\/\/[^\s]+)/g;
            var replacedText = nodeText.replace(urlRegex, function(url) {
            // Exclude anchor tags, img tags, href links, and text inside img tags
            if (node.parentNode.tagName !== 'A' && node.parentNode.tagName !== 'IMG' && node.parentNode.getAttribute('href') !== url && node.parentNode.getAttribute('src') !== url) {
                return '<a href="' + url + '" target="_blank">' + url + '</a>';
            } else {
                return url;
            }
            });
            if (replacedText !== nodeText) {
            var newNode = document.createElement('span');
            newNode.innerHTML = replacedText;
            node.parentNode.replaceChild(newNode, node);
            }
        });

        return tempElement.innerHTML;
    },   
    urlify(text) {
        var addHTTPsExp = /(\b((https?|ftp|file):\/\/|(www))[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|]*)/ig;   

        let newString = text.replace(addHTTPsExp, (url) => {
           let newLink = this.prependHTTPS(url);
           return newLink;
        });
        
        return  this.linkify(newString);
    },
    getChatHistory: function(user, scrollToBottom) 
    {        
        this.isFetching = true;

        if (this.page[this.userid] == 1) 
        {        
            /*[note] - first page we will remove current message since we will get it again on first page */
            this.chatlogs[user.userid] = [];
        }

        //user is the sender
        axios.post("/api/getChathistory", 
        {
            method              : "POST",
            sender_id           : this.userid, //login user id
            recipient_id        : user.userid, //chatbox user id (overrided to admin)
            page                : this.page[this.userid]                   

        }).then(response => {  
        
            if (response.data.success === true) 
            {               
                
                this.isFetching = false;
             
                let chatboxUsername = null;
                let chatboxNickname = null;
                let chatboxImage = null;

                this.page[this.userid] = response.data.chatHistoryItems.current_page + 1;

                
                //DETERMINE IF THE LAST PAGE
                if (response.data.chatHistoryItems.last_page == response.data.chatHistoryItems.current_page) {
                    //hide button for history
                    this.historyNotifier = false;                
                }
                
                let chatHistoryItems = response.data.chatHistoryItems.data;

                chatHistoryItems.forEach(data => {

                    if (data.message_type == "MEMBER") {

                        let member = this.getUser();
                        chatboxUsername = member.username;
                        chatboxNickname = member.nickname;
                        chatboxImage = this.user_image;       

                    } else {
                        chatboxUsername = "CUSTOMER SUPPORT";
                        chatboxNickname = "CUSTOMER SUPPORT"
                        chatboxImage = this.user_image;
                    }


                    //console.log(data);                
                    let sender = {
                        'msgCtr': 0,
                        'userid': data.userid,
                        'nickname': chatboxNickname,
                        'username': chatboxUsername,          
                        'user_image': chatboxImage,
                        'message': data.message,                            
                        'type': data.message_type
                    };



                    this.chatlogs[user.userid].unshift({
                        id: data.id,
                        time: data.created_at,
                        sender: sender,   
                    });
                });
                let reversedChatHistory =  this.chatlogs[user.userid];

                this.chatlogs[user.userid] = reversedChatHistory;

                this.$nextTick(()=>
                {  
                    this.$forceUpdate();
                    if (scrollToBottom == true) {
                        this.scrollToEnd();
                    } else {
                        this.scrollToTop();
                    }     
                });

                this.chatFetchStatus = "ACTIVE";

            } else {
                
                //hide button for history
                this.historyNotifier = false;

                this.isFetching = false;
            }
        
        }).catch(function(error) {

            this.isFetching = false;

            console.log("Error " + error);                
        });

    },
    scrollToTop: function() {
        this.$forceUpdate();

        var container = this.$el.querySelector("#user-chatlog");
        if(container) {            
            container.scrollTop = 0;
        }
    },
    scrollToEnd: function() 
    {
        this.$forceUpdate();   

        this.$nextTick(function()
        {      
            var container = this.$el.querySelector("#user-chatlog");
            if(container){
                container.scrollTop = container.scrollHeight;
                console.log(container.scrollHeight)   
            }
        });

        this.$nextTick(function() {
            if (this.chatFetchStatus == "ACTIVE") {
                this.getPaginatedHistory();
            } else {
                //console.log("unable to fetch chat history result still busy, please try again")
            }
            
        });
    },
    updatetValue(value) {
        //this.files = value;
    },
    /**
     * Has changed
     * @param  Object|undefined   newFile   Read only
     * @param  Object|undefined   oldFile   Read only
     * @return undefined
     */
    inputFile: function(newFile, oldFile) 
    {

        this.prepareButtons();

        if (newFile && oldFile && !newFile.active && oldFile.active) 
        {
            if (newFile.xhr) {
                if ( newFile.xhr.status === 200) 
                {
                    //file information
                    let file = [{
                                'id'        : newFile.response.id,
                                'file_name' : newFile.response.file,
                                'size'      : newFile.response.size,
                            }];

                    var currentTime = new Date();
                    let time = currentTime.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true })

                    //get the sender from props  (admin)
                    let sender = {
                        'msgCtr': 0,
                        'userid': this.userid,
                        'nickname': this.nickname,
                        'username': this.username,          
                        'message': newFile.response.image,
                        'user_image':  this.user_image, //@todo: make this for customer support 
                        'type': "MEMBER"
                    };
                
                    /*
                    this.chatlogs[newFile.response.recipient_id].push({
                        sender: sender,
                        message: newFile.response.image,
                        time: time
                    });*/

                    this.$forceUpdate(); 

                    //get the sender from props (user)                        
                    let id = newFile.response.id

                    let recipient = {
                        'id': newFile.response.id,
                        'userid': newFile.response.recipient_id,
                        'username':  newFile.response.recipient_username,
                    };

                    const sock = this.getChatSocket();
                    if (sock) {
                        sock.emit("SEND_USER_MESSAGE", { id, time, recipient, sender });
                    } else {
                        console.warn('[chat-support] $socket missing — file share not broadcast');
                    }
                }               

            }
        }

        if (this.$refs.upload.uploaded) {
            // console.log("all queue uploaded");
            this.files = [];

              this.scrollToEnd();
        }
    },
    /**
     * Pretreatment
     * @param  Object|undefined   newFile   Read and write
     * @param  Object|undefined   oldFile   Read only
     * @param  Function           prevent   Prevent changing
     * @return undefined
     */
    inputFilter: function(newFile, oldFile, prevent) {
        if (newFile && !oldFile) {
            // Filter non-image file
            if (!/\.(jpeg|jpe|jpg|gif|png|webp|pdf|doc|docx)$/i.test(newFile.name)) {
                return prevent();
            }
        }


        if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
            // Create a blob field
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            if (URL && URL.createObjectURL) {
            newFile.blob = URL.createObjectURL(newFile.file)
            }
            // Thumbnails
            newFile.thumb = ''
            if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
            newFile.thumb = newFile.blob
            }
        }
    },
    prepareButtons: function() 
    {
        const root = this.$el;
        if (!root || !root.querySelector) {
            return;
        }

        const messageEl = root.querySelector("#message");
        const message = messageEl ? messageEl.value : (this.message[0] || '');
        const fileSelectBtn = root.querySelector("#file-select-button");
        const sendBtn = root.querySelector("#send-button");        
        
        if (message == "" && this.files.length == 0) {  

            if (fileSelectBtn) {
                fileSelectBtn.style.display = "block";
            }

            if (sendBtn) {
                sendBtn.style.display = "none";
            }
            
             
        } else {

            if (fileSelectBtn) {
                fileSelectBtn.style.display = "none";            
            }

            if (sendBtn) {
                sendBtn.style.display = "block";
            }
        }        
    },    
    openFloatingChatIcon() {
        if (this.showFloatingIcon) {
            this.showFloatingChatIcon = true;
        }
    },
    closeFloatingChatIcon() {
        this.showFloatingChatIcon = false;
    },    
    closeChatBox() {
        this.showChatbox = false;
        this.unread_message_count = 0;
    },
    openChatBox() 
    {
        this.showChatbox = true;
        let user = this.getUser();
        if (isNaN(this.page[user.userid])) {
            this.page[user.userid] = 1;            
        }
        this.loadOpenOutbox();
        this.scrollToEnd();

        //mark read after opening
        this.delayandMarkUnread();

        this.addImagePopupListener();
    },    
    addImagePopupListener() {

        //add the image viewer
        var chatboxElement = this.$el ? this.$el.querySelector('.chatbox') : null;
        
        // Check if the element with the class "chatbox" exists
        if (chatboxElement) {        
            // Add a click event listener to the "chatbox" element
            chatboxElement.addEventListener("click", this.imageViewerClick);
        } else {
            console.log("Element with class 'chatbox' not found");
        }

    },
    getUser() {
        return {
            userid: this.$props.userid ,
            username: this.username,
            nickname: this.nickname,
            user_image: this.user_image,    
            status: 'online',     
            type: "MEMBER",      
        } 
    },

    addChatEventListener() {
        // Listeners are declared on the `sockets` option (VueSocketIO).
        // REGISTER immediately and again on connect.
        this.registerUser();
    },
    initializeChatBox: function(user) 
    {   
      
	    //@note: user is the sender
        this.current_chatbox_userid = user.userid;    

        let found = false;

        //add new to array if not present
        for (var i in this.chatboxes) {
            if (user.username == this.chatboxes[i].username) {
                found = true;

                 console.log(user);
            }
        }

        if (found == false) {

            //this.chatboxes.push(user);			
			this.chatboxes = [user];

            //instantiate chat log for when send message logs it does not empty out
            this.chatlogs[user.userid] = [];

            this.$forceUpdate();

            this.$nextTick(function()
            {
                this.scrollToEnd();
                this.prepareButtons(); 
            });            
        }

        this.loadOpenOutbox();
    },
    getUnreadMemberMessages(userid) 
    {
        axios.post("/api/getUnreadChatMessages", 
        {
            method           : "POST",
            userID           : userid,
        }).then(response => {  

            if (response.data.success === true) 
            {

                this.unread_message_count = response.data.unreadMessageCount;

                response.data.chatItems.forEach(data => {

                    let chatboxUsername = null;
                    let chatboxNickname = null;
                    let chatboxImage = null;

                    if (data.message_type == "MEMBER") {

                        let member = this.getUser();

                        chatboxUsername = member.username;
                        chatboxNickname = member.nickname;
                        chatboxImage = this.user_image; 

                    } else {


                        chatboxUsername = "CUSTOMER SUPPORT";
                        chatboxNickname = "CUSTOMER SUPPORT"
                        chatboxImage = this.user_image;
                    }


                    let chatSupportMessages = {
                        'msgCtr': 0,
                        'userid': data.sender_id, //id of chat support                        
                        'nickname': chatboxNickname,
                        'username': chatboxUsername,          
                        'user_image': this.customer_support_image,
                        'message': data.message,                            
                        'type': data.message_type
                    };

                    //the admin is the customer support
                    let admin = this.getAdmin();

                    this.chatlogs[admin.userid].unshift({
                            id: data.id,
                            time: data.created_at,
                            sender: chatSupportMessages,
                    }); 
                });


                this.$forceUpdate();
            } else {
            
                this.unread_message_count = response.data.unreadMessageCount;
            }
        });
    },
    delayandMarkUnread() {
        console.log("delay fired")
        clearTimeout(this.interval);
        this.interval = setTimeout(this.prepeareMarkRead, 1500);
    },
    prepeareMarkRead() {
        this.markMessagesRead(this.userid)
    },
    markMessagesRead(userid) {

        console.log("marking read")
        clearInterval(this.interval);

        axios.post("/api/markChatMessagesRead", 
        {
            method           : "POST",
            userID           : userid,
            message_type     : 'CHAT_SUPPORT'
        }).then(response => {  

            if (response.data.success === true) 
            {              
                this.unread_message_count = 0;

                 clearInterval(this.interval);
            } else {
                clearInterval(this.interval);
            }

           
        });    
        
    },
    sendMessage: function(chatbox, index) 
    {
        //files is empty and message is empty, stop sending message
        if (this.files.length == 0 && (this.message[index] === "" || this.message[index] === undefined)) 
        {           
            return false;
        }

        // Only start upload when files are queued. Clicking a missing
        // #startUpload (or the wrong duplicate instance) used to throw and
        // abort the rest of sendMessage.
        if (this.files.length > 0) {
            const startUploadBtn = this.$el && this.$el.querySelector("#startUpload");
            if (startUploadBtn) {
                startUploadBtn.click();
            } else if (this.$refs.upload) {
                this.$refs.upload.active = true;
            }
        }

        if (this.message[index] === "" || this.message[index] === undefined || this.sendingText) {
            //No message just upload, or a text save is already in flight
            return;
        }

        var plainText = this.message[index];
        this.sendingText = true;
        this.deliverMemberText(chatbox, index, plainText, null, plainText);
    },
    deliverMemberText(chatbox, index, userMessage, outboxClientId, plainText) {
        if (!chatbox || !userMessage) {
            if (!outboxClientId) {
                this.sendingText = false;
            }
            if (outboxClientId) {
                this.$delete(this.resendingIds, outboxClientId);
            }
            return;
        }

        var currentTime = new Date();
        var id = chatbox.id || chatbox.userid;
        var time = currentTime.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true });
        var recipient = {
            'id': chatbox.id || chatbox.userid,
            'userid': chatbox.userid,
            'username': chatbox.username,
            'type': "CHAT_SUPPORT",
        };
        var sender = {
            'userid': this.userid,
            'username': this.username,
            'nickname': this.nickname,
            'message': userMessage,
            'user_image': this.user_image,
            'type': "MEMBER"
        };
        var self = this;

        axios.post("/api/saveCustomerSupportChat", {
            method: "POST",
            sender_id: this.userid,
            recipient_id: chatbox.userid,
            message: userMessage,
            is_read: false,
            valid: true,
            message_type: "MEMBER",
        }).then(function (response) {
            if (!outboxClientId) {
                self.sendingText = false;
            }
            if (outboxClientId) {
                self.$delete(self.resendingIds, outboxClientId);
            }
            if (!response.data || response.data.success !== true) {
                self.holdFailedText(chatbox, index, userMessage, outboxClientId, plainText);
                return;
            }

            if (outboxClientId) {
                self.removeOutboxItem(chatbox.userid, outboxClientId);
            }
            self.appendLocalMemberMessage(chatbox.userid, time, sender);

            var sock = self.getChatSocket();
            if (sock) {
                sock.emit("SEND_USER_MESSAGE", { id: id, time: time, recipient: recipient, sender: sender });
                sock.emit("SEND_OWNER_MESSAGE", {
                    id: id,
                    time: time,
                    broadcast_recipient: {
                        'id': self.id || self.userid,
                        'userid': self.userid,
                        'username': self.username,
                    },
                    broadcast_sender: {
                        'msgCtr': 0,
                        'userid': chatbox.userid,
                        'nickname': chatbox.nickname,
                        'username': chatbox.username,
                        'message': userMessage,
                        'user_image': chatbox.user_image,
                        'type': "MEMBER"
                    }
                });
            } else {
                console.warn('[chat-support] $socket missing — message saved via API only');
            }

            if (!outboxClientId && index !== null && index !== undefined && (plainText === undefined || self.message[index] === plainText)) {
                self.message[index] = "";
            }
            self.$forceUpdate();
            self.$nextTick(function () {
                self.scrollToEnd();
                self.prepareButtons();
            });
        }).catch(function () {
            if (!outboxClientId) {
                self.sendingText = false;
            }
            if (outboxClientId) {
                self.$delete(self.resendingIds, outboxClientId);
            }
            self.holdFailedText(chatbox, index, userMessage, outboxClientId, plainText);
        });
    },
    holdFailedText(chatbox, index, userMessage, outboxClientId, plainText) {
        if (!outboxClientId) {
            this.rememberUnsent(chatbox.userid, userMessage);
            if (index !== null && index !== undefined && (plainText === undefined || this.message[index] === plainText)) {
                this.message[index] = "";
            }
            this.$forceUpdate();
            this.$nextTick(function () {
                this.prepareButtons();
            }.bind(this));
        }
        this.scrollToEnd();
    },
    threadEndsWithMember(chatbox) {
        var logs = (chatbox && this.chatlogs[chatbox.userid]) || [];
        if (!logs.length) {
            return false;
        }
        var last = logs[logs.length - 1];
        return !!(last && last.sender && last.sender.type === "MEMBER");
    },
    appendLocalMemberMessage(supportId, timeLabel, sender) {
        if (!this.chatlogs[supportId]) {
            this.$set(this.chatlogs, supportId, []);
        }
        this.chatlogs[supportId].push({
            sender: sender,
            message: sender && sender.message,
            time: timeLabel,
        });
        this.$forceUpdate();
    },
    outboxStorageKey() {
        return "memberChatOutbox:" + String(this.userid);
    },
    readOutboxStore() {
        try {
            var raw = localStorage.getItem(this.outboxStorageKey());
            var parsed = raw ? JSON.parse(raw) : {};
            if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
                return {};
            }
            return parsed;
        } catch (e) {
            return {};
        }
    },
    writeOutboxStore(store) {
        try {
            var keys = Object.keys(store || {});
            if (!keys.length) {
                localStorage.removeItem(this.outboxStorageKey());
                return;
            }
            localStorage.setItem(this.outboxStorageKey(), JSON.stringify(store));
        } catch (e) {
            // Storage can be unavailable; the in-memory outbox still shows for this view.
        }
    },
    readConversationOutbox(supportId) {
        var store = this.readOutboxStore();
        var list = store[String(supportId)];
        return Array.isArray(list) ? list : [];
    },
    writeConversationOutbox(supportId, list) {
        var store = this.readOutboxStore();
        var key = String(supportId);
        if (!list || !list.length) {
            delete store[key];
        } else {
            store[key] = list;
        }
        this.writeOutboxStore(store);
    },
    loadOpenOutbox() {
        var supportId = this.current_chatbox_userid || this.getAdmin().userid;
        if (!supportId) {
            this.outbox = [];
            return;
        }
        this.outbox = this.readConversationOutbox(supportId).slice();
    },
    rememberUnsent(supportId, message) {
        if (!supportId || !message) {
            return;
        }
        var list = this.readConversationOutbox(supportId);
        list.push({
            clientId: "out-" + Date.now() + "-" + Math.floor(Math.random() * 100000),
            message: message,
            createdAt: new Date().toISOString(),
        });
        this.writeConversationOutbox(supportId, list);
        if (String(this.current_chatbox_userid) === String(supportId)) {
            this.outbox = list.slice();
        }
    },
    removeOutboxItem(supportId, clientId) {
        var list = this.readConversationOutbox(supportId).filter(function (item) {
            return item.clientId !== clientId;
        });
        this.writeConversationOutbox(supportId, list);
        if (String(this.current_chatbox_userid) === String(supportId)) {
            this.outbox = list.slice();
        }
    },
    resendOutbox(item, chatbox) {
        if (!item || !chatbox || this.resendingIds[item.clientId]) {
            return;
        }
        this.$set(this.resendingIds, item.clientId, true);
        this.deliverMemberText(chatbox, null, item.message, item.clientId, null);
    },
    discardOutbox(item, chatbox) {
        if (!item || !chatbox || this.resendingIds[item.clientId]) {
            return;
        }
        this.removeOutboxItem(chatbox.userid, item.clientId);
    },
    readSupportEdit(data) {
        if (!data || !data.sender) {
            return null;
        }
        var message = data.sender.message == null ? "" : String(data.sender.message);
        var deleted = message.match(/^\[\[cs-delete:(\d+)\]\]/);
        var edited = message.match(/^\[\[cs-edit:(\d+)\]\]/);
        var kind = null;
        var historyId = null;
        var clean = message;
        if (deleted || data.action === "delete" || data.sender.action === "delete") {
            kind = "delete";
            historyId = deleted ? deleted[1] : null;
            clean = deleted ? message.slice(deleted[0].length) : message;
        } else if (edited || data.action === "edit" || data.sender.action === "edit") {
            kind = "edit";
            historyId = edited ? edited[1] : null;
            clean = edited ? message.slice(edited[0].length) : message;
        }
        if (!kind) {
            return null;
        }
        if (historyId === null || historyId === "") {
            historyId = data.sender.history_id || data.id;
        }
        return { kind: kind, historyId: historyId, message: clean };
    },
    removeSupportMessage(historyId) {
        var key = historyId === undefined || historyId === null ? "" : String(historyId);
        var logsMap = this.chatlogs || {};
        var removed = false;
        Object.keys(logsMap).forEach(function (bucket) {
            var logs = logsMap[bucket];
            if (!Array.isArray(logs) || !key) {
                return;
            }
            for (var i = logs.length - 1; i >= 0; i--) {
                if (logs[i] && String(logs[i].id) === key) {
                    logs.splice(i, 1);
                    removed = true;
                }
            }
        });
        if (removed) {
            this.$forceUpdate();
            return true;
        }
        var buckets = Object.keys(logsMap);
        var order = buckets.filter(function (name) { return String(name) === "1"; })
            .concat(buckets.filter(function (name) { return String(name) !== "1"; }));
        for (var b = 0; b < order.length; b++) {
            var logs = logsMap[order[b]];
            if (!Array.isArray(logs)) {
                continue;
            }
            for (var i = logs.length - 1; i >= 0; i--) {
                if (logs[i] && logs[i].sender && logs[i].sender.type === "CHAT_SUPPORT") {
                    logs.splice(i, 1);
                    this.$forceUpdate();
                    return true;
                }
            }
        }
        return false;
    },
    writeSupportBubble(logs, index, message, historyId) {
        var item = logs[index];
        if (!item || !item.sender) {
            return;
        }
        this.$set(logs, index, Object.assign({}, item, {
            id: historyId || item.id,
            sender: Object.assign({}, item.sender, { message: message }),
        }));
    },
    applyEditedSupportMessage(historyId, message) {
        if (historyId === undefined || historyId === null || historyId === "" || message === undefined || message === null) {
            return false;
        }
        var key = String(historyId);
        var logsMap = this.chatlogs || {};
        var updated = false;
        var self = this;
        Object.keys(logsMap).forEach(function (bucket) {
            var logs = logsMap[bucket];
            if (!Array.isArray(logs)) {
                return;
            }
            logs.forEach(function (item, index) {
                if (item && String(item.id) === key && item.sender) {
                    self.writeSupportBubble(logs, index, message, historyId);
                    updated = true;
                }
            });
        });
        if (updated) {
            this.$forceUpdate();
        }
        return updated;
    },
    applyLatestSupportEdit(message, historyId) {
        var logsMap = this.chatlogs || {};
        var buckets = Object.keys(logsMap);
        var order = buckets.filter(function (key) { return String(key) === "1"; })
            .concat(buckets.filter(function (key) { return String(key) !== "1"; }));
        for (var b = 0; b < order.length; b++) {
            var logs = logsMap[order[b]];
            if (!Array.isArray(logs)) {
                continue;
            }
            for (var i = logs.length - 1; i >= 0; i--) {
                var item = logs[i];
                if (item && item.sender && item.sender.type === "CHAT_SUPPORT") {
                    this.writeSupportBubble(logs, i, message, historyId || item.id);
                    this.$forceUpdate();
                    return true;
                }
            }
        }
        return false;
    },
    formatOutboxMessage(message) {
        return String(message || "")
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/&lt;br\s*\/?&gt;/gi, "<br>");
    },
    updateUserList: function(users) 
    {
      this.users = users;      
      this.$forceUpdate();
    },
  	scrollToEnd: function() 
    {
        this.$forceUpdate();
              
        this.$nextTick(function()
        {
            var container = this.$el.querySelector("#user-chatlog");
            
            if (container) {
                container.scrollTop = container.scrollHeight;         
            }            
        });

    }    
  },
  computed: {
    showFloatingIcon() {
      return this.show_floating_icon !== false;
    },
  },
  mounted: function () 
  {
    if (!this.showFloatingIcon) {
      this.showFloatingChatIcon = false;
    }

    // Sidebar orange card calls window.openChatBox().
    window.openChatBox = this.openChatBox.bind(this);

    window.addEventListener("keyup", (e) =>
    {
        this.prepareButtons();       
    });

    let admin = this.getAdmin();

    this.initializeChatBox(admin);

    this.addChatEventListener();

    //This will get all the message from the customer support
    this.getUnreadMemberMessages(this.userid);

    //this.addImagePopupListener();

  },
  beforeDestroy: function () {
    if (window.openChatBox) {
      try {
        delete window.openChatBox;
      } catch (e) {
        window.openChatBox = undefined;
      }
    }
  },
};
</script>


<style scoped>


    #fileUpload {
        display: none;
    }


    .bg-blue {    
        background-color: #009fd9
    }
    .border-blue {
        border-color: #009fd9
    }
     

    .position-bottom-right {
        position: fixed;
        bottom: 0px;
        right: 75px;
        z-index: 999;
    }
    #floating-history-btn {
        font-size: 11px;
        padding: 2px 5px 2px;
        position: absolute;
        top: 42px;
        left: 215px;
        z-index: 1;
    }
 

    .btn-xs {
        font-size: 11px;
        padding: 2px 5px 2px;
    }

    .chatlog-wrapper {
        margin-top: 30px;
    }


    .chat-button {
        border-radius: 50%;
        height: 65px;
        width: 65px;
        padding: 0px;
    }


    .user-chatlog {
        border: 1px solid #ececec;
        padding: 5px 5px 15px;
        min-height: 380px;
        max-height: 380px;
        margin-bottom: 3px;
        overflow-x: hidden;
        overflow-y: scroll;
    }

    .member-info {
        text-align: right;
    }

    .member-image {
        float: right;
        border-radius: 50%;
        margin-left: 30px;
        border: 3px solid #ededed;
    }
 
    /*
    .chat-support-message {   
        color: #242322;
        background-color: #F2F6F9;
        width: -webkit-fit-content;
        width: -moz-fit-content;
        width: fit-content;
        display: block;
        margin-top: 5px;
        padding: 7px 25px 7px; 
        border-radius: 15px;
    }
    */

    .chat-support-message {
        position: relative;
        background: #F2F6F9;
        border-radius: .4em;
        width: -webkit-fit-content;
        width: -moz-fit-content;
        width: fit-content;
        display: block;
        margin-top: 5px;
        padding: 7px 25px 7px;     
    }

    .chat-support-message:after {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        width: 0;
        height: 0;
        border: 18px solid transparent;
        border-right-color: #f2f6f9;
        border-left: 0;
        border-top: 0;
        margin-top: -12px;
        margin-left: -18px;
    }    

    .member-message-container {    
        position: relative;
        float: right;
        max-width: max-content;
        width: 100%;
        text-align: left;
    }

   .member-message {
        color: #242322;
        background-color: #DBF4FC;
        border-radius: .4em;        
        width: -webkit-fit-content;
        width: -moz-fit-content;
        width: fit-content;
        max-width: 100%;
        display: block;
        margin-top: 5px;
        padding: 7px 25px 7px;
  }


    .member-message:after {
        content: '';
        position: absolute;
        right: 0;
        top: 50%;
        width: 0;
        height: 0;
        border: 18px solid transparent;
        border-left-color: #DBF4FC;
        border-right: 0;
        border-top: 0;
        margin-top: -12px;
        margin-right: -16px;
    }

    .member-message.is-failed {
        background: #fde8e8;
        color: #7a1f1f;
    }

    .member-message.is-failed:after {
        border-left-color: #fde8e8;
    }

    .member-chat-unsent {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 8px;
        clear: both;
        margin-top: 4px;
        font-size: 11px;
        color: #9b1c1c;
    }

    .member-chat-resend {
        border: 0;
        background: transparent;
        padding: 0;
        color: #b42318;
        font-size: 11px;
        font-weight: 700;
        cursor: pointer;
    }

    .member-chat-resend:disabled,
    .member-chat-discard:disabled {
        opacity: 0.6;
        cursor: default;
    }

    .member-chat-discard {
        border: 0;
        background: transparent;
        padding: 0;
        color: #6b7780;
        font-size: 11px;
        font-weight: 700;
        cursor: pointer;
    }

</style>